import { useState, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { AppContext, EMPTY_OBJECT, ERROR_SEVERITY } from 'commons-ui';

import { dehydrateFormData } from '../../utils/formDataParser';
import useService from '../../utils/useService';
import { Experiment, ExperimentFormData } from '../../utils/types';
import useSegmentService from '../../../userSegment/useService';

const useCreate = () => {
	const [showLoader, setShowLoader] = useState(false);
	const { showAlert } = useContext(AppContext);
	const history = useHistory();
	const { requestCreateExperiment } = useService();

	const { requestGetSegmentList } = useSegmentService();

	const fetchSelectOptions = async (search?: string) => {
		const response = await requestGetSegmentList({
			pageDetails: { pageNo: 1, pageSize: 20 },
			searchText: search ?? '',
			includeDraft: false
		});

		const selectOptions = response?.data
			?.map((item: any) => ({
				id: item.segmentId,
				label: item.name
			}))
			?.filter((item: any) => item.id);

		return selectOptions;
	};

	const createExperiment = (createdData: { experimentData: Experiment }) => {
		setShowLoader(true);

		const { experimentData } = createdData;

		requestCreateExperiment(experimentData).then(
			(res: any) => {
				if (res?.status !== 200 || !res?.data?.success) {
					showAlert(res?.data?.error || 'Error occured while creating the experiment', { type: ERROR_SEVERITY.ERROR });
					setShowLoader(false);
					return;
				}

				showAlert('Experiment created');
				setShowLoader(false);
				history.goBack();
			},
			(err: any) => {
				showAlert(`Error: ${err.response.data.error}`, { type: ERROR_SEVERITY.ERROR });
				setShowLoader(false);
			}
		);
	};

	const handleFormSubmit = (submittedData: ExperimentFormData): void => {
		createExperiment(dehydrateFormData(submittedData));
	};

	const handleFormCancel = () => {
		history.goBack();
	};

	return {
		data: EMPTY_OBJECT,
		showLoader,
		handleFormSubmit,
		handleFormCancel,
		setShowLoader,
		fetchSelectOptions
	};
};

export default useCreate;
